import { render, staticRenderFns } from "./spectrum-of-the-seas.vue?vue&type=template&id=12b33538&"
import script from "./spectrum-of-the-seas.vue?vue&type=script&lang=js&"
export * from "./spectrum-of-the-seas.vue?vue&type=script&lang=js&"
import style0 from "./spectrum-of-the-seas.vue?vue&type=style&index=0&id=12b33538&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports